export const community = {
  avatar: 'Photo de profil de {{name}}',
  breadcrumb: {
    overview: 'Réseau',
  },
  detail: {
    disabled: 'Le profil de ce membre n’est plus public.',
    error: {
      title: 'Erreur lors du chargement du profil.',
    },
  },
  enableCommunityProfileDialog: {
    actions: {
      goToSettings: 'Rendre le profil public',
    },
    description:
      'Vous aimeriez poser une question sur le forum, rechercher et trouver d’autres freelances, vous avez vu une mission qui vous intéresse ou vous souhaitez publier vous-même une mission ? <br/>Alors un profil Community public est la solution. Vous pouvez l’activer rapidement et facilement via votre profil.',
    title: 'Rejoignez notre Community',
  },
  header: {
    preview: 'Voir votre profil',
    title: 'Réseau',
  },
  infoCards: {
    activity: {
      action: 'Filtrer sur vos activités',
      description_one: '{{count}} freelance partage vos activités',
      description_other: '{{count}} freelances partagent vos activités',
      description_zero: 'Pas encore de freelances avec les mêmes activités',
      title: 'Freelances avec les mêmes activités',
    },
    error: 'Impossible de charger les données',
    profile: {
      action: 'Compléter le profil',
      description: 'Complétez votre profil au maximum et élargissez votre réseau.',
      title: 'Faites-vous trouver par les autres',
    },
    region: {
      action: 'Filtrer sur votre région',
      description_one: '{{count}} freelance est actif dans votre région',
      description_other: '{{count}} freelances sont actifs dans votre région',
      description_zero: 'Pas encore de freelances dans votre région',
      title: 'Freelances dans votre région',
    },
  },
  overview: {
    errorLoading: 'Une erreur s’est produite lors du chargement du réseau.',
    filters: {
      activity: {
        label: 'Activités',
      },
      name: {
        placeholder: 'Rechercher par nom',
      },
      openToWork: {
        text: 'Disponible pour des missions',
      },
      region: {
        label: 'Région',
      },
    },
    loading: 'Chargement des données…',
    locked: {
      button: 'Rendre le profil public',
      description: 'Rendez votre profil public pour faire partie de la Craft Community.',
      success: 'Votre profil est maintenant public. Bienvenue dans la Craft Community !',
    },
    resultCount_one: '{{count}} résultat',
    resultCount_other: '{{count}} résultats',
    resultCount_zero: 'Aucun résultat ne correspond à vos critères de recherche',
  },
  profileCard: {
    activeInRegion: 'Actif dans {{regions}}',
    footer: {
      behance: 'Behance',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      mail: 'E-mail',
      website: 'Site web',
    },
    openDialog: 'Voir le profil de {{name}}',
    openToWork: 'Disponible',
  },
  regions: {
    Abroad: 'Étranger',
    Antwerp: 'Anvers',
    Brussels: 'Bruxelles',
    EastFlanders: 'Flandre-Orientale',
    FlemishBrabant: 'Brabant flamand',
    Hainaut: 'Hainaut',
    Liege: 'Liège',
    Limburg: 'Limbourg',
    Luxembourg: 'Luxembourg',
    Namur: 'Namur',
    WalloonBrabant: 'Brabant wallon',
    WestFlanders: 'Flandre-Occidentale',
  },
};
